import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// material
import {
    Tooltip, Stack, TextField, Typography, Modal, FormControl, InputLabel, Select, MenuItem, Button,
    IconButton, Grid, Radio, RadioGroup, FormControlLabel, FormLabel, Divider, Dialog, DialogTitle,
    DialogContent, DialogContentText, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Box
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ParentIcon from "@mui/icons-material/Assignment"; // Replace with a relevant icon
import ChildIcon from "@mui/icons-material/Description"; // Replace with a relevant icon

import { startOfMonth, endOfMonth } from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import ModalPopUp from '../../Common/ModalPopUp';
import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import Iconify from '../../Iconify';

// -----------------------------------------------------------------------------------------------------

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '60vh',
    overflow: 'auto',
    borderRadius: '8px',
};


export default function IRQuestionnairesDetailsComponent({ copyQuestionariesData }) {
    const location = useLocation();
    const ParentQuestions = copyQuestionariesData?.copyQuestionariesData?.ParentQuestions || [];
    const Questions = copyQuestionariesData?.copyQuestionariesData?.Questions || [];
    const rowData = copyQuestionariesData?.rowData || {};

    console.log(">>>>>>>>>>>>>>>>>>>>>copyQuestionariesData", copyQuestionariesData, ParentQuestions, "parent", rowData,"editId", copyQuestionariesData.rowData)
    
    const TABLE_HEAD = [
        { field: "id", headerName: "ID", width: 70 },
        { field: "description", headerName: "Description", width: 150 },
        { field: "controlId", headerName: "Control ID", width: 150 },
        { field: "parentName", headerName: "Parent ID", width: 150 },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            renderCell: (cellValues) => (
                <>
                    <IconButton
                        onClick={(event) => {
                            handleClick(event, cellValues);
                        }}><Iconify icon="ic:outline-edit" width='20px' height='20px' color='primary.main' /></IconButton>
                </>
            ),
        },
        {
            field: "delete",
            headerName: "",
            width: 120,
            renderCell: (cellValues) => (
                <>
                    <IconButton
                        onClick={(event) => {
                            handleDelete(event, cellValues);
                        }}
                    >
                        <Iconify icon="ic:baseline-delete" width='20px' height='20px' color='primary.main' />
                    </IconButton>
                </>
            ),
        },
        
    ];

    const namedControls = [
        { id: 'TextBox', name: 'TextBox' },
        { id: 'Label', name: 'Label' },
        { id: 'DropDownlist', name: 'DropDownlist' },
        { id: 'RadioButton', name: 'RadioButton' },
        { id: 'Checkbox', name: 'Checkbox' }
    ];

    // Adding
    const [description, setDescription] = useState("");
    const [controlId, setControlId] = useState("");
    const [dataRows, setDataRows] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [showFirstDescription, setShowFirstDescription] = useState(false);
    const [clickedOnce, setClickedOnce] = useState(false);

    const [idData, setIdData] = useState('');
    const [name, setName] = useState('');
    const [tableName, setTableName] = useState('');
    const [where, setWhere] = useState('');
    const [defaultValue, setDefaultValue] = useState('');
    const [dataValue, setDataValue] = useState('');

    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);
    const [transformedData, setTransformedData] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedProductsId, setSelectedProductsId] = useState(Questions[0]?.ProductId || '');

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [userId, setUserId] = useState([]);
    const [effectiveFromValue, setEffectiveFromValue] = useState(
        rowData?.FromDate
            ? new Date(rowData.FromDate)
            : startOfMonth(new Date())
    );
    const [effectiveToValue, setEffectiveToValue] = useState(
        rowData?.ToDate
            ? new Date(rowData.ToDate)
            : endOfMonth(new Date()));

    const [isCheckedActive, setIsCheckedAcive] = useState(true);
    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [parentId, setParentId] = useState([]);
    const [selectParentId, setSelectParentId] = useState('');

    const [selectedParent, setSelectedParent] = useState(null);  // Initially, set it to null or empty
    const [openTreeView, setOpenTreeView] = useState(false);
    const [client, setClient] = useState( Questions[0]?.ClientId || '');
    
    const [selectedClient, setSelectedClient] = useState([]);
    const [bindName, setBindName] = useState(Questions?.[0]?.Name || '');

    const [disable, setDisable] = useState(false); 
    const [disableClient, setDisableClient] = useState(false); 

    const initialProductId =
        copyQuestionariesData?.copyQuestionariesData?.length > 0
            ? copyQuestionariesData.copyQuestionariesData[0].ProductId
            : '';

    const initialClientId =
        copyQuestionariesData?.copyQuestionariesData?.length > 0
            ? copyQuestionariesData.copyQuestionariesData[0].ClientId
            : '';

    const controlMapping = {
        "TextBox": 0,
        "DropDownlist": 1,
        "ListBox": 2,
        "CheckBox": 3,
        "CheckBoxList": 4,
        "RadioButton": 5,
        "label": 6
    };

    // Effect to transform dataRows whenever it changes
    // useEffect(() => {
    //    const transformed = dataRows.map(row => {
    //        const controlId = controlMapping[row.controlId] || -1;
    //        const { idData, name, where } = row;
    //        let defaultValue = "";
    //        const valueList = [];

    //        if (controlId === 1) {
    //            valueList.push(name);
    //        } else if (controlId === 3) {
    //            defaultValue = name;
    //            valueList.push(name);
    //        }

    //        return {
    //            ID: idData,
    //            NAME: name,
    //            WhereClause: where,
    //            Control: controlId,
    //            DefaultValue: defaultValue,
    //            ValueList: valueList
    //        };
    //    });
    //    setTransformedData(transformed);
    // }, [dataRows]);

    useEffect(() => {
        console.log("copyQuestionariesData:", copyQuestionariesData);

        const dataArray = Array.isArray(copyQuestionariesData?.copyQuestionariesData)
            ? copyQuestionariesData.copyQuestionariesData
            : copyQuestionariesData?.copyQuestionariesData?.Questions;

        if (!Array.isArray(dataArray)) {
            console.warn("copyQuestionariesData.copyQuestionariesData is not an array:", dataArray);
            return;
        }

        // First pass: Assign tempId based on QuestionDescription
        const initialRows = dataArray.map((item, index) => ({
            id: index + 1,
            description: item.QuestionDescription || "",
            controlId: item.ControlType || "",
            parentId: item.ParentId || 0,
            parentName: item.ParentName || "",
            idData: "",
            name: item.Name || "",
            tableName: item.TableName || "",
            where: item.Where || "",
            tempId: item.QuestionDescription || "",
            tempParentId: "", // to be set later
            originalId: item.QuestionId, // use this for parent lookup
        }));

        // Second pass: Assign tempParentId based on ParentId -> QuestionDescription
        const finalRows = initialRows.map((row) => {
            if (row.parentId && row.parentId !== 0) {
                const parentRow = initialRows.find(p => p.originalId === row.parentId);
                return {
                    ...row,
                    tempParentId: parentRow?.tempId || ""
                };
            }
            return row;
        });

        console.log("Final Transformed dataRows with tempId & tempParentId:", finalRows);
        setDataRows(finalRows);
    }, [copyQuestionariesData]);


    useEffect(() => {
        URLS.getOAProductsDropDown()
            .then((response) => {

                setProducts(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getParentQuestionaries()
            .then((response) => {

                setParentId(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getClientMasterData()
            .then((response) => {
                setSelectedClient(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);
    // Function to handle save
    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setClickedOnce(true);
    }, [clickedOnce]);

    useEffect(() => {
        if (initialProductId) {
            setDisable(true); 
        } else {
            setDisable(false); 
        }
    }, [initialProductId]);

    useEffect(() => {
        if (initialClientId) {
            setDisableClient(true);
        } else {
            setDisableClient(false); 
        }
    }, [initialClientId]);
    

    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue)
    };

    const handleIsActiveChange = (event) => {
        setIsCheckedAcive(event.target.checked);
    };
    const handleBindNameChange = (event) => {
        setBindName(event.target.value)
    }
    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/oa/installationreportquestionaries', { replace: true });
            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);

    };
    const handleProducts = (id) => {
        setSelectedProductsId(id);
    };
    const handleParentId = (id) => {
        setSelectParentId(id);

    };
    const handleClients = (id) => {
        setClient(id);

    };

    const handleCancelDelete = () => {
        console.log("Cancel delete clicked");
        setOpenDeleteModal(false);
    }

    const handleChangeControl = (id) => {
        setControlId(id);

    };
  
    const handleClick = (event, row) => {
        event.stopPropagation();
        console.log("Selected cell:", row);

        setSelectedRowId(row.id);
        setDescription(row.description);
        setControlId(row.controlId);
        setSelectParentId(row.parentId); // ✅ number
    };


    const handleAddData = () => {
        if (!selectedProductsId) {
            enqueueSnackbar("Please select product");
            return;
        }
        if (selectedProductsId && description.length === 0) {
            enqueueSnackbar("Please enter description");
            return;
        }
        if (!controlId) {
            enqueueSnackbar("Please select control type");
            return;
        }

        // Determine parent info
        let newParentId = '';
        let newParentName = '';
        let newTempParentId = '';

        // First check in dataRows
        let parentRow = dataRows.find(row => row.id === Number(selectParentId));

        // If not found, check in API ParentQuestions
        if (!parentRow && copyQuestionariesData?.copyQuestionariesData?.ParentQuestions) {
            parentRow = copyQuestionariesData.copyQuestionariesData.ParentQuestions.find(
                (row) => row.Id === Number(selectParentId)
            );
            if (parentRow) {
                newParentId = parentRow.Id;
                newParentName = parentRow.QuestionDescription;
                newTempParentId = parentRow.QuestionDescription;
            }
        }

        // If found in dataRows
        if (parentRow && !newParentId) {
            newParentId = parentRow.id;
            newParentName = parentRow.description;
            newTempParentId = parentRow.tempId || parentRow.description;
        }

        const newTempId = description;

        const newDataRow = {
            id: dataRows.length + 1,
            description,
            controlId,
            parentId: newParentId || '',
            parentName: newParentName || '',
            idData: idData || '',
            name: name || '',
            tableName: tableName || '',
            where: where || '',
            tempId: newTempId,
            tempParentId: newTempParentId || '',
        };

        const newDataRows = [...dataRows, newDataRow];

        console.log('New Data Rows:', newDataRows);

        // Reset form
        setDescription('');
        setDataRows(newDataRows);
        setIdData('');
        setName('');
        setTableName('');
        setWhere('');
        setDefaultValue('');
        setDataValue('');
        setControlId('');
        setSelectParentId('');
    };


    const handleDelete = (event, row) => {
        event.stopPropagation(); // Prevent event bubbling
        console.log("Item to delete:", row);
        setItemToDelete(row); // Set the row to be deleted
        setOpenDeleteModal(true); // Open the delete confirmation modal

    };
    // Function to confirm deletion
    const confirmDelete = () => {
        if (itemToDelete) {
            const updatedDataRows = dataRows.map(row =>
                row.id === itemToDelete.id
                    ? { ...row, IsDelete: 1 }
                    : { ...row, IsDelete: row.IsDelete ?? 0 } // ensure IsDelete exists
            );

            setDataRows(updatedDataRows);
        }

        setOpenDeleteModal(false);
        setItemToDelete(null);
    };

    console.log("dataRows", dataRows)
    const handleSave = () => {
        // Convert transformedData into the desired format
        const savedData = transformedData.map(item => ({
            [item.ID]: {
                ID: item.ID,
                NAME: item.NAME,
                WhereClause: item.WhereClause,
                Control: item.Control,
                DefaultValue: item.DefaultValue,
                ValueList: item.ValueList
            }
        }));

        // Here you can implement the logic to save savedData
        console.log("Saving data:", savedData);
        // Example: send savedData to server, or save it to local storage, etc.
    };

    const handleUpdateData = () => {
        if (selectedRowId !== null) {
            const updatedRows = dataRows.map(row => {
                if (row.id === selectedRowId) {
                    const updatedControlId = controlId;
                    let showControlValuePanel = true;
                    let updatedParentId = row.parentId;
                    let updatedParentName = row.parentName;
                    let updatedTempParentId = row.tempParentId;
                    // Check if the control type is changed to TextBox or Label
                    if ((row.controlId === 'TextBox' || row.controlId === 'Label') && (controlId === 'DropDownList' || controlId === 'RadioButton' || controlId === 'Checkbox')) {
                        showControlValuePanel = false;
                    } else if ((row.controlId === 'DropDownList' || row.controlId === 'RadioButton' || row.controlId === 'Checkbox') && (controlId === 'TextBox' || controlId === 'Label')) {
                        showControlValuePanel = false;
                    }
                    // const parent = parentId.find((p) => p.Id === selectParentId);
                    // if (parent) {
                    //    updatedParentId = parent.Id;
                    //    updatedParentName = parent.QuestionDescription;
                    // }
                    const parentRow =
                        dataRows.find(r => r.id === Number(selectParentId)) ||
                        copyQuestionariesData?.copyQuestionariesData?.ParentQuestions?.find(p => Number(p.Id) === Number(selectParentId));

                    if (parentRow) {
                        updatedParentId = Number(parentRow.id || parentRow.Id);
                        updatedParentName = parentRow.description || parentRow.QuestionDescription;
                        updatedTempParentId = parentRow.tempId || parentRow.description || parentRow.QuestionDescription;
                    }

                    return {
                        ...row,
                        description,
                        controlId: updatedControlId,
                        showControlValuePanel,
                        parentId: updatedParentId,
                        parentName: updatedParentName,
                        tempParentId: updatedTempParentId,
                        tempId: row.tempId || row.description  // retain existing or use description
                    };
                }
                return row; 
            });
            setDataRows(updatedRows);
            setSelectedRowId(null);
            setDescription('');
            setControlId('');
            setSelectParentId('');
        }
    };
    const formik = useFormik({
        initialValues: {
            ProductId: selectedProductsId ,
            FromDate: effectiveFromValue,
            ToDate: effectiveToValue,
            IsActive: isCheckedActive,
        },

        onSubmit: (values, actions) => {
            if (!selectedProductsId) {
                enqueueSnackbar("Please select product");
                return;
            }
            if (description.length===0 &&  dataRows.length === 0) {
                enqueueSnackbar("Please enter description");
                return;
            }

            if (dataRows.length === 0 && !controlId) {
                enqueueSnackbar("Please select control type");
                return;
            }
            if (dataRows.length === 0) {
                enqueueSnackbar("Please add at least one record before proceeding.");
                return;
            }
            const installationReportId =
                Array.isArray(copyQuestionariesData?.copyQuestionariesData) &&
                    copyQuestionariesData.copyQuestionariesData.length > 0 &&
                    copyQuestionariesData?.rowData?.InstallationReportQuestionnairesMasterId !== undefined &&
                    copyQuestionariesData.rowData?.InstallationReportQuestionnairesMasterId !== null
                    ? copyQuestionariesData.rowData.InstallationReportQuestionnairesMasterId
                    : 0;

            // const rawQuestions =
            //    Array.isArray(copyQuestionariesData?.copyQuestionariesData?.Questions)
            //        ? copyQuestionariesData.copyQuestionariesData.Questions
            //        : Array.isArray(copyQuestionariesData?.copyQuestionariesData)
            //            ? copyQuestionariesData.copyQuestionariesData
            //            : [];

            let rawQuestions = [];

            if (Array.isArray(copyQuestionariesData?.copyQuestionariesData?.Questions)) {
                rawQuestions = copyQuestionariesData.copyQuestionariesData.Questions;
            } else if (Array.isArray(copyQuestionariesData?.copyQuestionariesData)) {
                rawQuestions = copyQuestionariesData.copyQuestionariesData;
            }

            const questionIdMap = new Map(
                rawQuestions.map(q => [
                    q.QuestionDescription?.trim() || "",
                    q.QuestionId || q.Id || 0
                ])
            );

            const fromDate = Moment(effectiveFromValue).format("DD-MMM-YYYY");
            const toDate = Moment(effectiveToValue).format("DD-MMM-YYYY");
            const payload = {
                Id: ParentQuestions[0]?.InstallationReportQuestionnairesMasterId || 0,
                ProductId: selectedProductsId,
                FromDate: fromDate,
                ToDate: toDate,
                IsActive: isCheckedActive,
                LoggedInUserId: userId,
                ClientId: client || 0,
                Name: bindName || "",
                saveQuestionariesList: dataRows.map((row, index) => {
                    const apiParentList = copyQuestionariesData?.copyQuestionariesData?.ParentQuestions;
                    const apiParentIds = new Set((apiParentList || []).map((p) => p.Id));

                    // Default parentId is 0
                    let parentId = 0;

                    if (copyQuestionariesData?.copyQuestionariesData) {
                        // If ParentQuestions list exists
                        if (apiParentList?.length > 0) {
                            parentId = apiParentIds.has(parseInt(row.parentId, 10))
                                ? parseInt(row.parentId, 10)
                                : (
                                    apiParentList.find(
                                        (p) =>
                                            p.QuestionDescription?.trim().toLowerCase() ===
                                            row.tempParentId?.trim().toLowerCase()
                                    )?.Id || 0
                                );
                        } else if (row.tempParentId) {
                            // Match TempParentId with TempId and fetch corresponding Sequence or Id
                            const matchedParent = dataRows.find(
                                (p) =>
                                    p.tempId?.trim().toLowerCase() ===
                                    row.tempParentId?.trim().toLowerCase()
                            );

                            parentId = matchedParent?.sequence || matchedParent?.id || 0;
                        }
                    } else {
                        // If no copyQuestionariesData exists, fallback to original row.parentId
                        parentId = row.parentId && row.parentId !== 0
                            ? parseInt(row.parentId, 10)
                            : 0;
                    }



                    return {
                        Id: Array.isArray(copyQuestionariesData?.copyQuestionariesData?.Questions)
                            ? (questionIdMap.get(row.description?.trim()) || 0)
                            : 0,
                        Description: row.description || "",
                        ControlType: row.controlId || "",
                        ParentId: parentId,
                        DataValueId: row.idData || 0,
                        Name: row.name || "",
                        TableName: row.tableName || "",
                        Where: row.where || "",
                        IsActive: isCheckedActive,
                        Sequence: index + 1,
                        QueestionariesMasterId: copyQuestionariesData?.rowData?.InstallationReportQuestionnairesMasterId || 0,
                        TempId: row.tempId || "",
                        TempParentId: row.tempParentId || "",
                        IsDelete: row.IsDelete ?? 0
                    };
                })
            };

            console.log("payload", payload);

              URLS.saveQuestionaries(payload)
                .then((response) => {
                    enqueueSnackbar("Saved data successfully.", { variant: 'success' });
                    navigate('/dashboard/oa/installationreportquestionaries');

                })
                .catch(error => {
                    enqueueSnackbar("Data not Saved.", { variant: 'error' });
                });
        },
    });

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedData = [...dataRows];
        const [movedItem] = reorderedData.splice(result.source.index, 1);
        reorderedData.splice(result.destination.index, 0, movedItem);

        // Step 1: Assign new IDs
        const tempIdMap = {};
        const updatedWithNewIds = reorderedData.map((item, index) => {
            const newId = index + 1;
            const updated = { ...item, id: newId };
            const tempKey = item.tempId?.trim().toLowerCase();
            if (tempKey) tempIdMap[tempKey] = updated;
            return updated;
        });

        // Step 2: Resolve parentId and parentName from tempParentId
        const finalData = updatedWithNewIds.map((item) => {
            let parentId = 0;
            let parentName = "";

            const tempParentKey = item.tempParentId?.trim().toLowerCase();
            const parentItem = tempIdMap[tempParentKey];

            if (parentItem) {
                parentId = parentItem.id;
                parentName = parentItem.description;
            }

            return {
                ...item,
                parentId,
                parentName,
            };
        });

        setDataRows(finalData);
    };


    const buildTree = (data) => {
        const tree = [];
        const map = {};
        const parentNameMap = {};

        // Create map of all items
        data.forEach((item) => {
            map[item.id] = { ...item, children: [] };
        });

        data.forEach((item) => {
            const isRoot = item.parentId === "" || item.parentId === 0;

            if (isRoot) {
                tree.push(map[item.id]);
            } else {
                const realParent = Object.values(map).find(
                    (node) => node.description === item.parentName
                );

                if (realParent) {
                    // Attach to existing real parent
                    realParent.children.push(map[item.id]);
                } else {
                    // Create virtual parent node if not already created
                    if (item.parentName && !parentNameMap[item.parentName]) {
                        parentNameMap[item.parentName] = {
                            id: `parent_${item.parentId}`,
                            description: item.parentName,
                            children: [],
                        };
                        tree.push(parentNameMap[item.parentName]);
                    }

                    // Attach to virtual parent if it exists
                    if (item.parentName && parentNameMap[item.parentName]) {
                        parentNameMap[item.parentName].children.push(map[item.id]);
                    } else if (map[item.parentId]) {
                        // Fallback: attach to parent by ID
                        map[item.parentId].children.push(map[item.id]);
                    }
                }
            }
        });

        return tree;
    };


    const treeData = buildTree(dataRows);
    const renderTree = (nodes) =>
        nodes.map((node) => (
            <TreeItem
                key={node.id}
                nodeId={node.id.toString()}
                label={
                    <Box display="flex" alignItems="center">
                        {node.children.length > 0 ? (
                            <ParentIcon sx={{ mr: 1, color: "#1976d2" }} />
                        ) : (
                            <ChildIcon sx={{ mr: 1, color: "#64b5f6" }} />
                        )}
                        {node.description}
                    </Box>
                }
                sx={{
                    "& .MuiTreeItem-group": {
                        borderLeft: "1px solid rgba(0, 0, 0, 0.2)", // Creates the vertical tree lines
                        marginLeft: "15px",
                        paddingLeft: "8px",
                    },
                }}
            >
                {node.children.length > 0 && renderTree(node.children)}
            </TreeItem>
        ));


    const apiParentQuestions = copyQuestionariesData?.copyQuestionariesData?.ParentQuestions || [];

    // Step 1: Normalize API parent questions
    const apiParentOptions = apiParentQuestions.map(p => ({
        id: Number(p.Id),
        description: p.QuestionDescription
    }));
    const apiParentDescriptions = new Set(apiParentOptions.map(p => p.description.trim().toLowerCase()));

    const manualParentOptions = dataRows
        .filter(
            row =>
                (!row.parentId || row.parentId === "0") &&
                !apiParentDescriptions.has(row.description.trim().toLowerCase())
        )
        .map(row => ({
            id: Number(row.id),
            description: row.description
        }));

    // Step 3: Combine both
    const parentOptions = [...apiParentOptions, ...manualParentOptions];
    console.log('API Parents:', apiParentOptions);
    console.log('Manual Parents:', manualParentOptions);
    console.log('Combined Parents:', parentOptions);


    const visibleRows = dataRows.filter(row => row.IsDelete !== 1);

    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;


    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit} >
                <Stack spacing={2}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                        <FormControl size="small" fullWidth>
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Products</InputLabel>
                            <Select
                                label="Prducts"
                                size="small"
                                value={selectedProductsId}
                                disabled={disable} 
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}
                            >
                                <MenuItem key={0} value={""} onClick={() => handleProducts()} >Select</MenuItem>

                                {products.map((product) => (
                                    <MenuItem key={product.Id} value={product.Id} onClick={() => handleProducts(product.Id)}>{product.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size="small" fullWidth>
                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Clients</InputLabel>
                            <Select
                                label="Clients"
                                size="small"
                                value={client}
                                disabled={disableClient}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7', // Set the background color here
                                            maxHeight: '200px',
                                            width: '200px',// Set the max height here
                                        }
                                    }
                                }}
                            >
                                <MenuItem key={0} value={""} onClick={() => handleClients()} >Select</MenuItem>

                                {selectedClient.map((client) => (
                                    <MenuItem key={client.ContactId} value={client.ContactId} onClick={() => handleClients(client.ContactId)}>{client.Name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            fullWidth
                            size="small"
                            label="Name"
                            value={bindName}
                            onChange={handleBindNameChange}
                        />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                fullWidth
                                label="From Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveFromValue).format('DD-MMM-yyyy')}
                                onChange={handleEffFrom}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                fullWidth
                                label="To Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveToValue).format('DD-MMM-yyyy')}
                                onChange={handleEffTo}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                            />
                        </LocalizationProvider>

                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={isCheckedActive} onChange={handleIsActiveChange} />} label="IsActive" style={{ width: '150px' }} />
                        </FormGroup>
                    </Stack>
                    <Divider mb={2} />
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                        <Grid container spacing={2} direction={{ xs: "column", sm: "row" }}>
                            {/* Description TextField */}
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    size="small"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Grid>

                            {/* Control Type Dropdown */}
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Control Type</InputLabel>
                                    <Select
                                        label="Control Type"
                                        size="small"
                                        value={controlId}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    backgroundColor: '#fbe9e7',
                                                    maxHeight: '200px',
                                                    width: '200px',
                                                },
                                            },
                                        }}
                                        onChange={(e) => setControlId(e.target.value)}
                                    >
                                        <MenuItem key={0} value={""}>Select</MenuItem>
                                        {namedControls.map((product) => (
                                            <MenuItem key={product.id} value={product.id} onClick={() => handleChangeControl(product.id)}>
                                                {product.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Parent Id Dropdown */}
                            {dataRows.length > 0 && (
                                <Grid item xs={12} sm={4} md={3}>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Parent Id</InputLabel>
                                        <Select
                                            label="Parent Id"
                                            size="small"
                                            value={selectParentId}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7',
                                                        maxHeight: '200px',
                                                        width: '200px',
                                                    },
                                                },
                                            }}
                                            onChange={(e) => setSelectParentId(e.target.value)}
                                        >
                                            <MenuItem key={0} value={""}>Select</MenuItem>
                                            {parentOptions.map((row) => (
                                                <MenuItem key={row.id} value={row.id}>
                                                    {row.description}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={4} md={3}>
                                <IconButton size="small" onClick={() => {
                                    if (dataRows.length > 0) {
                                        setOpenTreeView(true);
                                    }
                                }}>
                                    <Iconify icon="ic:baseline-account-tree" width="18px" height="18px" color="primary.main" />
                                </IconButton>

                                <Modal open={openTreeView} onClose={() => setOpenTreeView(false)}>
                                    <Box sx={modalStyle}>
                                        <IconButton
                                            onClick={() => setOpenTreeView(false)}
                                            sx={{ position: "absolute", top: 10, right: 10, color: "grey" }}
                                        >
                                            <CloseIcon />
                                        </IconButton>

                                        <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                                            {renderTree(treeData)}
                                        </TreeView>
                                    </Box>
                                </Modal>
                            </Grid>
                            {/* Control Type Description */}
                            {showFirstDescription && (
                                <Grid item xs={12} sm={4} md={3}>
                                    <Typography>
                                        <span style={{ fontWeight: 'bold' }}>Control Type:</span> {dataRows[0].description}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Stack>

                    {(controlId === "DropDownlist" || controlId === "RadioButton" || controlId === "CheckBox") && (
                        <>
                            <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>

                                <TextField
                                    fullWidth
                                    label="Id"
                                    size="small"
                                    value={idData} // Assuming 'id' is a state variable
                                    onChange={(e) => setIdData(e.target.value)} // Assuming you have a corresponding state update function setId
                                />

                                <TextField
                                    fullWidth
                                    label="Name"
                                    size="small"
                                    value={name} // Assuming 'name' is a state variable
                                    onChange={(e) => setName(e.target.value)} // Assuming you have a corresponding state update function setName
                                />

                                <TextField
                                    fullWidth
                                    label="Table Name"
                                    size="small"
                                    value={tableName} // Assuming 'tableName' is a state variable
                                    onChange={(e) => setTableName(e.target.value)} // Assuming you have a corresponding state update function setTableName
                                />
                            </Stack>

                            <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>

                                <TextField
                                    fullWidth
                                    label="Where"
                                    size="small"
                                    value={where} // Assuming 'where' is a state variable
                                    onChange={(e) => setWhere(e.target.value)} // Assuming you have a corresponding state update function setWhere
                                />

                                <TextField
                                    fullWidth
                                    label="Default Values"
                                    size="small"
                                    value={defaultValue} // Assuming 'where' is a state variable
                                    onChange={(e) => setDefaultValue(e.target.value)} // Assuming you have a corresponding state update function setWhere
                                />

                                <TextField
                                    fullWidth
                                    label="Data Values"
                                    size="small"
                                    value={dataValue} // Assuming 'where' is a state variable
                                    onChange={(e) => setDataValue(e.target.value)} // Assuming you have a corresponding state update function setWhere
                                />
                            </Stack>

                        </>

                    )}

                    <Grid spacing={4}>

                        <Grid item xs={12} sm={6} md={2} lg={0.8}>
                            {selectedRowId ?
                                <Button
                                    sx={{ color: 'white' }}
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUpdateData}
                                >
                                    Update
                                </Button> :
                                <Button
                                    sx={{ color: 'white' }}
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddData}
                                >
                                    Add
                                </Button>}
                        </Grid>
                    </Grid>
                
                    <Grid container spacing={1} sx={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                            <TableContainer component={Paper} sx={{ height: 250, width: "100%", overflow: "auto" }}>
                                <DragDropContext onDragEnd={handleDragEnd}>
                                    <Droppable droppableId="table">
                                        {(provided) => (
                                            <Table {...provided.droppableProps} ref={provided.innerRef} size="small">
                                                <TableHead>
                                                    <TableRow sx={{ height: "30px" }}> 
                                                        <TableCell sx={{ padding: "4px" }}>ID</TableCell>
                                                        <TableCell sx={{ padding: "4px" }}>Description</TableCell>
                                                        <TableCell sx={{ padding: "4px" }}>Control ID</TableCell>
                                                        <TableCell sx={{ padding: "4px" }}>Parent ID</TableCell>
                                                        <TableCell sx={{ padding: "4px" }}>Actions</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {visibleRows.map((row, index) => (
                                                        <Draggable key={row.id} draggableId={String(row.id)} index={index}>
                                                            {(provided) => (
                                                                <TableRow
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    sx={{ height: "30px" }} // Reduce row height
                                                                >
                                                                    <TableCell sx={{ padding: "4px", width: "2%" }}>{row.id}</TableCell>
                                                                    <TableCell sx={{ padding: "4px", width: "15%" }}>{row.description}</TableCell>
                                                                    <TableCell sx={{ padding: "4px", width: "10%" }}>{row.controlId}</TableCell>
                                                                    <TableCell sx={{ padding: "4px", width: "20%" }}>{row.parentName}</TableCell>
                                                                    <TableCell sx={{ padding: "4px", width: "20%" }}>
                                                                        <IconButton size="small" onClick={(event) => handleClick(event, row)}>
                                                                            <Iconify icon="ic:outline-edit" width="18px" height="18px" color="primary.main" />
                                                                        </IconButton>
                                                                        <IconButton size="small" onClick={(event) => handleDelete(event, row)}>
                                                                            <Iconify icon="ic:baseline-delete" width="18px" height="18px" color="primary.main" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </TableBody>
                                            </Table>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </TableContainer>
                        </Grid>
                    </Grid>


                    <Grid item xs={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" spacing={2}>
                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                sx={{ color: 'white' }}
                            >
                                Save
                            </LoadingButton>
                            <Button
                                sx={{ color: 'white' }}
                                onClick={handelCancelClick}
                                size="medium"
                                variant="contained"
                                color="primary"
                            >
                                Cancel
                            </Button>
                        </Stack>
                    </Grid>
                </Stack>



            </Form>
            {openDeleteModal && (
                <ModalPopUp
                    openCloseValue={openDeleteModal}
                    msg={`Do you want to delete ?`}
                    confirm={(isConfirmed) => {
                        if (isConfirmed) {
                            confirmDelete(); // Delete only when "Yes" is clicked
                        } else {
                            handleCancelDelete(); // Just close modal when "No" is clicked
                        }
                    }}
                />

            )}
            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}

        </FormikProvider>
    );
}